import axios from 'axios';
import {createAction} from 'redux-actions';

export const get = createAction('GET_PROJECTS', async () => (await axios(`${API}/acf/v3/projekt?per_page=30`)).data);

export const getId = createAction('GET_PROJECT', async id => {
	const {data: [body]} = await axios(`${API}/acf/v3/projekt/?slug[]=${id}`);

	if (!body) {
		return false;
	}

	return body;
});



// WEBPACK FOOTER //
// actions/projects.js